// components
import { Placeholder } from 'rsuite';
// styles
import styles from './PosCardSkeleton.module.css';

const PosCardSkeleton = () => {
    return (
        <div className={styles['wrapper']}>
            <div className={styles['description']}>
                <div className={styles['redounded']}>
                    <Placeholder.Paragraph graph="circle" active />
                </div>

                <div className={styles['data']}>
                    <Placeholder.Paragraph rows={1} active />
                    <Placeholder.Paragraph rows={1} active />
                    <Placeholder.Paragraph rows={1} active />
                </div>
            </div>

            <div className={styles['avatars']}>
                <Placeholder.Paragraph graph="circle" active />
                <Placeholder.Paragraph graph="circle" active />
                <Placeholder.Paragraph graph="circle" active />
            </div>

            <div style={{ visibility: 'hidden' }}>
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path
                        d="M10.5 9.99935L7.24998 6.74935C7.0972 6.59657 7.02081 6.40213 7.02081 6.16602C7.02081 5.9299 7.0972 5.73546 7.24998 5.58268C7.40276 5.4299 7.5972 5.35352 7.83331 5.35352C8.06942 5.35352 8.26387 5.4299 8.41665 5.58268L12.25 9.41602C12.3333 9.49935 12.3923 9.58963 12.4271 9.68685C12.4618 9.78407 12.4791 9.88824 12.4791 9.99935C12.4791 10.1105 12.4618 10.2146 12.4271 10.3118C12.3923 10.4091 12.3333 10.4993 12.25 10.5827L8.41665 14.416C8.26387 14.5688 8.06942 14.6452 7.83331 14.6452C7.5972 14.6452 7.40276 14.5688 7.24998 14.416C7.0972 14.2632 7.02081 14.0688 7.02081 13.8327C7.02081 13.5966 7.0972 13.4021 7.24998 13.2494L10.5 9.99935Z"
                        fill="#40435B"
                    />
                </svg>
            </div>
        </div>
    );
};

export default PosCardSkeleton;
